export default __webpack_public_path__ + "static/media/gold-chest-open.4df50268.png";